import AddVehicle from './vehicle/AddVehicle';
import ReplaceVehicle from './vehicle/ReplaceVehicle';
import DeleteVehicle from './vehicle/DeleteVehicle';
import AddDriver from './driver/AddDriver';
//import EditDriver from './driver/EditDriver';
import DeleteDriver from './driver/DeleteDriver';
import AddCreditor from './creditor/AddCreditor';
import EditCreditor from './creditor/EditCreditor';
// import AddMailingAddress from './mailingaddress/AddMailingAddress';
// import EditMailingAddress from './mailingaddress/EditMailingAddress';
// import DeleteMailingAddress from './mailingaddress/DeleteMailingAddress';
import { faCar, faUserPlus, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons'
import DriverEmailDetails from './driver/DriverEmailDetails';
import VehicleEmailDetails from './vehicle/VehicleEmailDetails';
import CreditorEmailDetails from './creditor/CreditorEmailDetails';


export default function (policy) {
	const canDeleteVehicle = policy && policy.vehicles.length > 1;
	const canDeleteDriver = policy && policy.drivers.filter(d => d.relationshipTypeId !== 8 && d.relationshipTypeId !== 5).length > 0;
	const canAddCreditor = policy && policy.vehicles.length > 0;
	const canEditCreditor = policy && policy.vehicles.some((v) => v.creditors != null && v.creditors.length > 0);

	const actions =  [
		{
			header: 'Vehicle',
			icon: faCar,
			actions: [
				{ title: 'Add', id: 'vehicleAddBtn', component: AddVehicle, header: 'Add Vehicle', data: { type: 'vehicle', action: 'add' }, disabled: !policy, showFraudWarning: true, emailDetailsComponent: VehicleEmailDetails },
				{ title: 'Replace', id: 'vehicleReplaceBtn', component: ReplaceVehicle, header: 'Replace Vehicle', data: { type: 'vehicle', action: 'replace' }, disabled: !policy, showFraudWarning: true, emailDetailsComponent: VehicleEmailDetails },
				{ title: 'Delete', id: 'vehicleDeleteButton', component: DeleteVehicle, header: 'Delete Vehicle', data: { type: 'vehicle', action: 'delete' }, disabled: !canDeleteVehicle, emailDetailsComponent: VehicleEmailDetails },
			],
		},
		{
			header: 'Driver',
			icon: faUserPlus,
			actions: [
				{ title: 'Add', id:'driverAddBtn', component: AddDriver, header: 'Add Driver', data: { type: 'driver', action: 'add' }, disabled: !policy, showFraudWarning: true, emailDetailsComponent: DriverEmailDetails },
				// { title: 'Edit', id: 'driverEditBtn', component: EditDriver, header: 'Edit Driver', data: { type: 'driver', action: 'edit' }, emailDetailsComponent: DriverEmailDetails, isError: true, message: 'For help with making changes to your policy please contact your agent.' },  //disabled: !policy,
				{ title: 'Delete', id: 'driverDeleteBtn', component: DeleteDriver, header: 'Delete Driver', data: { type: 'driver', action: 'delete' }, isError: !canDeleteDriver, message: 'There are no drivers eligible to be deleted. Please contact your agent.', emailDetailsComponent: DriverEmailDetails },
			],
		},
		// {
		// 	header: 'Mailing Address',
		//  icon: 'mailbox',
		// 	actions: [
		// 		{ title: 'Add', component: AddMailingAddress, header: 'Add Mailing Address', data: { type: 'address', action: 'add' } },
		// 		{ title: 'Edit', component: EditMailingAddress, header: 'Edit Mailing Address', data: { type: 'address', action: 'edit' } },
		// 		{ title: 'Delete', component: DeleteMailingAddress, header: 'Delete Mailing Address', data: { type: 'address', action: 'delete' } },
		// 	],
		// },
	];

	if(canAddCreditor || canEditCreditor) {
		actions.push({
			header: 'Lienholder or Loss Payee',
			icon: faFileInvoiceDollar,
			actions: [
				{ title: 'Add', id: 'addLienholderBtn', component: AddCreditor, header: 'Add Lienholder or Loss Payee', data: { type: 'creditor', action: 'add' }, disabled: !canAddCreditor, showFraudWarning: true, emailDetailsComponent: CreditorEmailDetails },
				{ title: 'Edit', id: 'editLienholderBtn', component: EditCreditor, header: 'Edit Lienholder or Loss Payee', data: { type: 'creditor', action: 'edit' }, disabled: !canEditCreditor, emailDetailsComponent: CreditorEmailDetails },
				// { title: 'Delete', id: 'deleteLienholderBtn', header: 'Delete Lienholder or Loss Payee', isError: true, message: 'To remove a lienholder from your account please contact your Agent.', emailDetailsComponent: CreditorEmailDetails },
			],
		})
	}

	return actions;
}
